<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="small">
            <el-form-item>
                <el-button
                    type="primary"
                    icon="el-icon-edit"
                    @click.native="handleInput(null, null)"
                >添加</el-button
                >
            </el-form-item>
            <el-form-item class="query-form-item" label="发货仓">
                <el-select
                    v-model="query.repertorysid"
                    placeholder="请选择发货仓"
                    style="width:150px"
                    @change="onSubmit"
                    clearable
                >
                    <el-option
                        v-for="(item, index) in comRepertorys"
                        :key="index"
                        :label="item.repertorysname"
                        :value="item.repertorysid"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="query-form-item" label="分类">
                <el-select
                    v-model="query.classifyid"
                    placeholder="请选择分类"
                    style="width:150px"
                    @change="onSubmit"
                    clearable
                >
                    <el-option
                        v-for="(item, index) in comClassifys"
                        :key="index"
                        :label="item.classifytitle"
                        :value="item.classifyid"
                    ></el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item class="query-form-item" label="品牌">
                <el-select
                    v-model="query.brandid"
                    placeholder="请选择品牌"
                    style="width:150px"
                    @change="onSubmit"
                    clearable
                >
                    <el-option
                        v-for="(item, index) in comBrands"
                        :key="index"
                        :label="item.brandtitle"
                        :value="item.brandid"
                    ></el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item class="query-form-item">
                <el-input
                    placeholder="商品名称/产品编码"
                    v-model="query.commoditytest"
                    @change="onSubmit"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
                <!--            <el-button type="primary" icon="el-icon-upload" @click="onImport">导入</el-button >-->
                <el-button type="primary" icon="el-icon-download"  size="small" @click="exportExcel()" >导出</el-button>
                <el-button type="primary" icon="el-icon-download" @click.native="modelDownLoad">下载模板</el-button>
                <!-- <el-button type="primary" icon="el-icon-upload2" @click.native="handleForm(null,null)">批量导入</el-button> -->
                <!-- 4期之前的导入 -->
<!--                <el-upload-->
<!--                    class="upload-btn"-->
<!--                    :action="uploadAction"-->
<!--                    :show-file-list="false"-->
<!--                    :on-success="handleAvatarSuccess"-->
<!--                    :on-error="handleAvatarError"-->
<!--                    :before-upload="uploadLoadings"-->
<!--                    accept=".xls, .xlsx"-->
<!--                    multiple-->
<!--                >-->
<!--                    <el-button size="small" type="primary" icon="el-icon-upload2">导入</el-button>-->
<!--                </el-upload>-->
                <!-- 4期导入 -->
                <el-button size="small" type="primary" icon="el-icon-upload2" @click="Import">导入</el-button>
            </el-form-item>
        </el-form>
        <!-- <el-scrollbar class="table-scrollbar" wrap-style="overflow-x: hidden;"> -->
        <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="list"
            :header-cell-style="{ background: '#F4F4F5', color: '#606266' }"
            @selection-change="handleSelectionChange"
            border
        >
            <el-table-column
                label="选择"
                prop="orderid"
                type="selection"
                :show-overflow-tooltip="true"
                width="50"
                align="center"
            />
<!--            <el-table-column label="产品编码" align="center" prop="commoditynum" />-->
            <el-table-column label="序列号" align="center" prop="commoditynum" />
            <el-table-column label="发货仓" align="center" prop="repertorysname" />
            <el-table-column label="商品名称" align="center" prop="commodityname" />
            <el-table-column label="材质规格" align="center" prop="specstand" />
            <el-table-column label="分类" align="center" prop="classifytitle" />
            <el-table-column label="库存量" align="center" prop="comrepositorynum" />
            <el-table-column width="200" label="操作" align="center">
                <template slot-scope="scope">
                    <el-button
                        type="primary"
                        size="mini"
                        @click.native="handleForm(scope.$index, scope.row)"
                    >修改</el-button
                    >
                    <el-button
                        type="danger"
                        size="mini"
                        @click.native="handleDel(scope.row.comrepertoryid)"
                    >删除</el-button
                    >
                </template>
            </el-table-column>
        </el-table>

        <div class="left-container">
            <el-button type="danger" size="small" @click="delGroup()"
            >删除已选</el-button
            >
            <transition name="el-fade-in-linear">
                <el-button size="small" @click="toggleSelection()" v-show="cancelToggle"
                >取消选择</el-button
                >
            </transition>
        </div>
        <el-pagination
            class="pagination-container"
            background
            :page-size="query.pageSize"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            layout="total,sizes,prev, pager, next, jumper"
            :current-page="query.currentPage"
            :page-sizes="[10, 20, 30, 50]"
            :total="totalNumber"
        ></el-pagination>

        <!--增加-->
        <el-dialog
            class="adddialog"
            :visible.sync="formInput"
            :before-close="hideFormAdd"
            width="800px"
            top="5vh"
            v-dialogDrag
            title="添加"
        >
            <el-form :model="formData" :rules="addFormRules" ref="addDataForm">
                <el-form-item
                    class="query-form-item"
                    label="发货仓"
                    prop="repertorysid"
                >
                    <el-select
                        v-model="formData.repertorysid"
                        placeholder="请选择发货仓"
                        style="width:30%;"
                        clearable
                    >
                        <el-option
                            v-for="(item, index) in comRepertorys"
                            :key="index"
                            :label="item.repertorysname"
                            :value="item.repertorysid"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="选择商品:" prop="commodityid">
                    <el-input :value="this.formData.commodityname" style="width:30%" readonly/>
                    <el-button
                        style="margin-left: 5px;"
                        type="primary"
                        icon="el-icon-search"
                        @click="onSearchCommodity"
                    >查询</el-button
                    >
                </el-form-item>

                <el-form-item class="query-form-item" label="规格材质" prop="specid">
                    <el-select
                        v-model="formData.specid"
                        placeholder="请选择规格材质"
                        style="width:30%"
                        clearable
                    >
                        <el-option
                            v-for="(item, index) in comSpecs"
                            :key="index"
                            :label="item.specstand"
                            :value="item.specid"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="库存:" prop="comrepositorynum">
                    <el-input
                        style="width: 30%;"
                        v-model="formData.comrepositorynum"
                        clearable
                    ></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideFormInput">取消</el-button>
                <el-button
                    type="primary"
                    @click.native="formSub()"
                    :loading="formLoading"
                >保存</el-button
                >
            </div>
        </el-dialog>

        <!--修改-->
        <el-dialog
            :visible.sync="formVisible"
            :before-close="hideForm"
            width="800px"
            top="5vh"
            v-dialogDrag
            title="修改"
        >
            <el-form :model="formData" :rules="updateFormRules" ref="updateDataForm">
                <el-form-item label="修改库存量">
                    <el-input
                        style="width: 130px;"
                        v-model.number="formData.comrepositorynum"
                        clearable
                        maxlength=9
                        minlength=1
                        @input="v => formData.comrepositorynum = v.replace(/[^\d]/g,'')"
                    ></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideForm">取消</el-button>
                <el-button
                    type="primary"
                    @click.native="formSubmit()"
                    :loading="formLoading"
                >保存</el-button
                >
            </div>
        </el-dialog>

        <!--商品-->
        <el-dialog
            :visible.sync="formAddCommodity"
            :before-close="hideFormCommodity"
            v-dialogDrag
        >
            <el-form :inline="true" :model="queryDialog" class="query-form" size="small">
                <el-form-item class="query-form-item" label="分类">
                    <el-select
                        v-model="queryDialog.classifyid"
                        placeholder="请选择分类"
                        style="width:150px"
                        @change="onSubmitAddRecomCommodity"
                        clearable
                    >
                        <el-option
                            v-for="(item, index) in comClassifys"
                            :key="index"
                            :label="item.classifytitle"
                            :value="item.classifyid"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="query-form-item" label="品牌">
                    <el-select
                        v-model="queryDialog.brandid"
                        placeholder="请选择品牌"
                        style="width:150px"
                        @change="onSubmitAddRecomCommodity"
                        clearable
                    >
                        <el-option
                            v-for="(item, index) in comBrands"
                            :key="index"
                            :label="item.brandtitle"
                            :value="item.brandid"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="query-form-item" prop="commodityid">
                    <el-input
                        placeholder="商品名称"
                        v-model="queryDialog.commodityname"
                        @change="onSubmitAddRecomCommodity"
                        clearable
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        icon="el-icon-search"
                        @click="onSubmitAddRecomCommodity"
                    >查询</el-button
                    >
                </el-form-item>
            </el-form>

            <el-table
                ref="multipleTable"
                v-loading="loading"
                :data="listAddCommodity"
                :header-cell-style="{ background: '#F4F4F5', color: '#606266' }"
                @selection-change="handleSelectionChange"
                border
            >
                <el-table-column label="产品编码" align="center" prop="commoditynum" />
                <el-table-column
                    label="缩略图"
                    prop="commodityurl"
                    align="center"
                    width="200"
                >
                    <template slot-scope="scope">
                        <el-popover placement="right" trigger="hover">
                            <img
                                :src="scope.row.commodityurl"
                                style="width:400px;border-radius:3px;"
                            />
                            <img
                                slot="reference"
                                :src="scope.row.commodityurl"
                                style="max-height: 50px;max-width: 50px;border-radius:5px;"
                            />
                        </el-popover>
                    </template>
                </el-table-column>

                <el-table-column label="商品名称" align="center" prop="commodityname" />
                <el-table-column label="分类" align="center" prop="classifytitle" />
                <el-table-column label="品牌" align="center" prop="brandtitle" />
                <el-table-column label="价格" align="center" prop="specprice">
                    <template slot-scope="scope">
                        <span>{{ scope.row.specprice | price(scope.row.specprice) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="序列号" align="center" prop="commoditysort" />
                <el-table-column width="200" label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="primary"
                            size="mini"
                            @click.native="
                handleAddCommodity(
                  scope.row.commodityid,
                  scope.row.commodityname
                )
              "
                        >添加</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <el-pagination
                    class="pagination-container2"
                    background
                    :page-size="queryDialog.pageSize"
                    @size-change="handleSizeChangeDeilog"
                    @current-change="handleCurrentChangeDeilog"
                    layout="total,sizes,prev, pager, next, jumper"
                    :page-sizes="[10, 20, 30, 50]"
                    :current-page="queryDialog.currentPage"
                    :total="addCommoditytotalNumber"
                ></el-pagination>
            </div>
        </el-dialog>

        <!-- 导入库存数据弹出层 -->
        <el-dialog title="批量导入库存" width="400px" :visible.sync="dialogImportInventoryVisible" :before-close="handleClose">
            <div class="export-goods">
                <div class="export-title">
                </div>
                <div class="export-Inventory">
                    <span>1、请导出目前库存数据:</span>
                    <span class="export-Inventory-btn" @click="exportExcel">导出目前库存数据</span>
                </div>
                <span>2、请导入更新的库存数据:</span>
                <div style="margin-top: 20px;margin-bottom: 15px;text-align: center" class="export-export-upload">
                    <el-upload
                        class="upload-btn"
                        :action="uploadAction"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :on-error="handleAvatarError"
                        :before-upload="uploadLoadings"
                        accept=".xls, .xlsx"
                        multiple
                    >
                        <el-button size="small" type="success">上传</el-button>
                    </el-upload>
                </div>
                <div class="export-Inventory-info" ><i class="el-icon-warning-outline" style="margin-left: 5px;"></i>需导出目前数据再修改上传</div>
                <span>3、批量导入结果</span>
                <div class="export-result-info">
                    <span style="color: #67C23A;" v-show="hideWorsd">导入成功！共导入{{this.total.total}}条数据，成功{{this.total.successTotal}}条数据！</span>
                    <span style="color: #F56C6C;text-decoration: underline;cursor: pointer;" v-show="hideWorsd1" @click="errDownload">导入失败！共导入{{this.total.total}}条数据，成功{{this.total.successTotal}}条数据，失败{{this.total.errorTotal}}条数据！</span>
                </div>
                <div style="text-align: center;">
                    <el-button type="primary" @click="ok">确定</el-button>
                </div>
            </div>
        </el-dialog>
        <!-- 导入库存数据弹出层 -->
    </div>
</template>

<script>
    import {
        getList,
        getComRepertorys,
        getClassify,
        getBrand,
        getSpec,
        deleteRepertory,
        addRepertory,
        updateRepertory,
        getAddRecomCommodityList
    } from "../../api/product/repertory.js";
    import { BASE_URL } from "../../config/app";
    const formJson = {
        repertorysid: "",
        commodityid: "",
        specid: "",
        comrepositorynum: ""
    };
export default {
        data() {
            var checkNum = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error("请输入库存量"));
                } else {
                    var reg = /^[0-9]*$/;
                    if (reg.test(value)) {
                        callback();
                    } else {
                        return callback(new Error("请输入正整数"));
                    }
                }
            };
            var checkRepertory = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error("请选择发货仓"));
                } else {
                    callback();
                }
            };
            var checkCommodity = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error("请选择商品"));
                } else {
                    callback();
                }
            };
            var checkSpec = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error("请选择规格材质"));
                } else {
                    callback();
                }
            };
            return {
                comrepertoryid: "",
                repertorysid: "",
                commoditynum: "",
                repertorysname: "",
                commodityname: "",
                specstand: "",
                classifytitle: "",
                brandtitle: "",
                comrepositorynum: "",
                dialogVisible: false,
                cancelToggle: false,
                servicestarttime: [],
                query: {
                    repertorysid: "",
                    classifyid: "",
                    brandid: "",
                    comrepertoryid: "",
                    commoditytest: "",
                    commodityid: "",
                    commodityname: "",
                    commoditytype: "",
                    currentPage: 1,
                    pageSize: 10
                },
                savequery:{

                },
                queryDialog: {
                    classifyid: "",
                    brandid: "",
                    commodityname:"",
                    currentPage: 1,
                    pageSize: 10
                },
                list: [],
                listAddCommodity: [],
                totalNumber: 0,
                addCommoditytotalNumber: 0,
                loading: false,
                index: null,
                formName: null,
                formLoading: false,
                formVisible: false,
                formInfo: false,
                formInput: false,
                formImport: false,
                formAddCommodity: false,
                formData: formJson,
                updateFormRules: {
                    comrepositorynum: [{ validator: checkNum, trigger: "blur" }]
                },
                addFormRules: {
                    repertorysid: [{ validator: checkRepertory, trigger: "blur" }],
                    commodityid: [{ validator: checkCommodity, trigger: "blur" }],
                    specid: [{ validator: checkSpec, trigger: "blur" }],
                    comrepositorynum: [{ validator: checkNum, trigger: "blur" }]
                },
                multipleSelection: [], //多选集合

                comRepertorys: [], //发货仓
                comClassifys: [], //分类
                comBrands: [], //品牌
                comSpecs: [], //规格
                // uploadAction :BASE_URL +"/repertoryManage/sensitiveImport",
                uploadAction :BASE_URL +"/repertoryManage/sensitiveImportV4",
                // 导入库存弹出层开关
                dialogImportInventoryVisible:false,
                total: [],
                hideWorsd: false,
                hideWorsd1: false
            };
        },
        methods: {
            //首页-开始
            //加载发货仓
            getComRepertorys() {
                getComRepertorys().then(response => {
                    if (response.code) {
                        this.$message.error(response.message);
                    }
                    this.comRepertorys = response.data || [];
                    console.log(this.comRepertorys);
                }).catch(() => {
                    this.comRepertorys = [];
                });
            },
            //加载分类
            getClassify() {
                getClassify().then(response => {
                    if (response.code) {
                        this.$message.error(response.message);
                    }
                    this.comClassifys = response.data || [];
                    console.log(this.comClassifys);
                }).catch(() => {
                    this.comClassifys = [];
                });
            },
            // 品牌集合
            getBrand() {
                getBrand()
                    .then(response => {
                        if (response.code) {
                            this.$message.error(response.message);
                        }
                        this.comBrands = response.data || [];
                    })
                    .catch(() => {
                        this.comBrands = [];
                    });
            },
            getList() {
                this.loading = true;
                getList(this.query)
                    .then(response => {
                        if (response.code) {
                            this.$message.error(response.message);
                        }
                        this.list = response.data.list || [];
                        this.totalNumber = response.data.totalNumber || 0;
                        setTimeout(() => {
                            this.loading = false;
                        }, 0.3 * 1000);
                    })
                    .catch(() => {
                        this.loading = false;
                        this.list = [];
                        this.totalNumber = 0;
                    });
            },
            handleCurrentChange(val) {
                this.query.currentPage = val;
                //scrollTo(0, 800);
                this.getList();
            },
            handleSizeChange(val) {
                this.query.pageSize = val;
                this.getList();
            },
            delGroup() {
                var ids = this.multipleSelection.map(item => item.comrepertoryid).join(); //获取所有选中行的id组成的字符串，以逗号分隔
                if (ids == "") {
                    this.$message({
                        message: "请先选择",
                        type: "warning"
                    });
                    return;
                }
                this.handleDel(ids);
            },
            // 删除
            handleDel(ids) {
                if (ids) {
                    this.$confirm("确认要删除吗?", "提示", {
                        type: "warning"
                    })
                        .then(() => {
                            this.loading = true;
                            // var params = new URLSearchParams();
                            // params.append("ids", ids.toString());
                            deleteRepertory({ids:ids.toString()})
                                .then(response => {
                                    this.loading = false;
                                    if (response.code) {
                                        this.$message.error(response.message);
                                        return false;
                                    }
                                    this.$message.success("删除成功");
                                    // 刷新数据
                                    //this.list.splice(index, 1);
                                    this.getList();
                                })
                                .catch(() => {
                                    this.loading = false;
                                });
                        })
                        .catch(() => {});
                }
            },
            //首页-结束

            //取消上传
            handleClose(){
                this.hideWorsd = false;
                this.hideWorsd1 = false;
                this.dialogImportInventoryVisible=false;
                this.getList();
            },
            ok(){
                this.handleClose()
            },

            Import() {
                this.query.repertorysid = "";
                this.query.classifyid = "";
                this.query.commoditytest = "";
                this.getList();
                this.dialogImportInventoryVisible=true;
            },

            //加载规格
            getSpec(id) {
                if (id) {
                    this.loading =true;
                    getSpec(id).then(response => {
                        if (response.code) {
                            this.$message.error(response.message);
                        }
                        this.comSpecs = response.data || [];
                        console.log(this.comRepertorys);
                        setTimeout(() => {
                            this.loading = false;
                        }, 0.3 * 1000);
                    });
                }
            },
            uploadLoadings(){
                this.loading=true;
            },
            handleAvatarSuccess(response) {
                if (response.code) {
                    this.$message.error(response.message);
                    return false;
                }
                this.total = response.data;
                if (response.data.errorTotal == 0) {
                    this.hideWorsd = true;
                    this.hideWorsd1 = false;
                } else {
                    this.hideWorsd1 = true;
                    this.hideWorsd = false;
                }
                // this.$message.success("导入成功");
                this.getList();
            },
            handleAvatarError() {
                this.$message.error("上传文件出错");
            },
            //模版下载
            modelDownLoad() {
                window.location.href = BASE_URL + "/repertoryManage/modelDownLoad";
            },
            //导出
            // exportExcel() {
            //     window.location.href = BASE_URL + "/repertoryManage/export";
            // },
            // 导出 4期
            exportExcel() {
                var ids = this.multipleSelection.map(item => item.comrepertoryid).join(); //获取所有选中行的id组成的字符串，以逗号分隔
                window.location.href = BASE_URL + "/repertoryManage/exportV4?ids="+ ids + "&repertorysid=" + this.query.repertorysid
                    + "&classifyid=" + this.query.classifyid + "&commoditytest=" + this.query.commoditytest;
            },
            // 错误数据下载
            errDownload() {
                window.location.href = this.total.url;
            },

            //商品展示
            onSearchCommodity() {
                this.formAddCommodity = true;
                this.query.commoditytype = 0;
                this.onSubmitAddRecomCommodity();
            },
            onSubmitAddRecomCommodity() {
                this.loading =true;
                getAddRecomCommodityList(this.queryDialog)
                    .then(response => {
                        if (response.code) {
                            this.$message.error(response.message);
                        }

                        this.listAddCommodity = response.data.list || [];
                        this.addCommoditytotalNumber = response.data.totalNumber || 0;
                        setTimeout(() => {
                            this.loading = false;
                        }, 0.3 * 1000);
                    })
                    .catch(() => {
                        this.loading = false;
                        this.listAddCommodity = [];
                        this.addCommoditytotalNumber = 0;
                    });
            },

            //添加商品
            handleAddCommodity(id, name) {
                this.query.commodityid = id;
                this.query.commodityname = name;
                this.formData.commodityid = id;
                this.formData.commodityname = name;
                this.formAddCommodity = !this.formAddCommodity;
                this.getSpec(id);
            },

            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            dateChange(val) {
                if (val == null) {
                    this.query.startTime = "";
                    this.query.endTime = "";
                } else {
                    this.query.startTime = val[0];
                    this.query.endTime = val[1];
                }
                this.getList();
            },
            toggleSelection(rows) {
                if (rows) {
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row);
                    });
                } else {
                    this.$refs.multipleTable.clearSelection();
                }
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                if (val == "") {
                    this.cancelToggle = false;
                    return;
                }
                this.cancelToggle = true;
            },
            onRest() {
                this.query = {
                    currentPage: 1,
                    pageSize: 10
                };
                this.getList();
            },
            onSubmit() {
                this.$router.push({
                    path: "",
                });
                this.getList();
            },
            handleCurrentChangeDeilog(val) {
                this.queryDialog.currentPage = val;
                //scrollTo(0, 800);
                this.onSubmitAddRecomCommodity();
            },
            handleSizeChangeDeilog(val) {
                this.queryDialog.pageSize = val;
                this.onSubmitAddRecomCommodity();
            },


            // 隐藏表单
            hideForm() {
                // 更改值
                this.formVisible = !this.formVisible;
                this.$refs["updateDataForm"].resetFields();
                this.formData={};
                return true;
            },
            // hideFormUpdate() {
            //   // 更改值
            //   this.formVisible = !this.formVisible;
            //   this.$refs["updateDataForm"].resetFields();
            //   this.$refs["addDataForm"].resetFields();
            //   return true;
            // },

            hideFormCommodity() {
                // 更改值
                this.formAddCommodity = !this.formAddCommodity;
                this.queryDialog= {
                    classifyid: "",
                    brandid: "",
                    commodityname:"",
                    currentPage: 1,
                    pageSize: 10
                },
                    this.listAddCommodity=[];
            },

            hideFormInput() {
                // 更改值
                this.formInput = !this.formInput;
                this.$refs["updateDataForm"].resetFields();
                this.$refs["addDataForm"].resetFields();
                this.query.commoditytest = "";
                return true;
            },
            hideFormAdd() {
                // 更改值
                this.formInput = !this.formInput;
                this.$refs["updateDataForm"].resetFields();
                this.$refs["addDataForm"].resetFields();
                this.query.commoditytest = "";
                return true;
            },
            hideFormImport() {
                // 更改值
                this.formImport = !this.formImport;
                return true;
            },

            hideInfo() {
                // 更改值
                this.formInfo = !this.formInfo;
                // 清空表单
                this.$refs["updateDataForm"].resetFields();
                this.$refs["addDataForm"].resetFields();
                this.$refs.tinymce.clearContent();
                this.query.commoditytest = "";
                return true;
            },
            hideInput() {
                // 更改值
                this.formInput = !this.formInput;
                // 清空表单
                this.$refs["updateDataForm"].resetFields();
                this.$refs["addDataForm"].resetFields();
                this.query.commoditytest = "";
                return true;
            },
            // 显示表单
            handleForm(index, row) {
                this.formVisible = true;
                if (row !== null) {
                    this.formData = Object.assign({}, row);
                }
            },

            handleInput(index, row) {
                this.formInput = true;
                this.formData = Object.assign({}, formJson);
                if (row !== null) {
                    this.formData = Object.assign({}, row);
                }
                //编辑
                if (index !== null) {
                    this.index = index;
                    let vm = this;
                    setTimeout(function() {
                        vm.$nextTick(() => {
                            if (vm.$refs.tinymce) {
                                vm.$refs.tinymce.setContent(vm.formData.problemanswer);
                            }
                        });
                    }, 350);
                }
                // 清空验证信息表单
                if (this.$refs["addDataForm"]) {
                    this.$refs["addDataForm"].clearValidate();
                }

                if (this.$refs["updateDataForm"]) {
                    this.$refs["updateDataForm"].clearValidate();
                }
            },

            onImport() {
                this.formImport = true;
            },

            formSubmit() {
                this.$refs["updateDataForm"].validate(valid => {
                    if (valid) {
                        this.formLoading = true;
                        let data = Object.assign({}, this.formData);
                        console.log(data);
                        updateRepertory(data).then(response => {
                            this.formLoading = false;
                            if (response.code) {
                                this.$message.error(response.message);
                                return false;
                            }
                            this.$message.success("操作成功");
                            this.formVisible = false;
                            // 刷新表单
                            this.getList();
                            this.$refs["updateDataForm"].resetFields();
                            // this.$refs["addDataForm"].resetFields();
                            //this.$refs.tinymce.clearContent();

                            this.query.repertorysid = "";
                            this.query.classifyid = "";
                            this.query.brandid = "";
                            this.query.commoditytest = "";
                        });
                    }
                });
            },

            formSub() {
                this.$refs["addDataForm"].validate(valid => {
                    if (valid) {
                        this.formLoading = true;
                        let data = Object.assign({}, this.formData);
                        console.log(data);
                        addRepertory(data).then(response => {
                            this.formLoading = false;
                            if (response.code) {
                                this.$message.error(response.message);
                                return false;
                            }
                            this.$message.success("操作成功");
                            this.formInput = false;
                            this.getList();
                            // 刷新表单
                            // this.$refs["updateDataForm"].resetFields();
                            this.$refs["addDataForm"].resetFields();

                            this.query.commoditytest = "";
                        });
                    }
                });
            }
        },
        filters: {
            price: function(myInput) {
                var val = parseInt(myInput);
                if (typeof val === "number") {
                    return val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
                }
            }
        },
        created() {
            // // 将参数拷贝进查询对象
            // let query = this.$route.query;
            // this.query = Object.assign(this.query, query);
            // this.query.pageSize = parseInt(this.query.pageSize);
            // 品牌集合
            this.getBrand();
            // 加载表格数据
            //加载发货仓
            this.getComRepertorys();
            //加载分类
            this.getClassify();
            this.getList();
        }
    };
</script>

<style type="text/scss" lang="scss">
    body {
        margin: 0;
    }
    .upload-btn {
        display: inline-block;
    }
    .adddialog .el-form-item__label{
        width: 100px;
    }
    .export-goods{
        height: 100%;
    }
    .export-goods .export-title{
        display: flex;
        align-items: center;
    }
    .export-Inventory-info{
        color: orange;
        display: block;
        font-size: 12px;
        margin-bottom: 20px;
        text-align: center;
    }
    .export-Inventory{
        margin-bottom: 20px;
    }
    .export-Inventory-btn{
        text-decoration: underline;
        color: blue;
        margin-left: 10px;
        cursor: pointer;
    }
    .export-export-upload{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 44px;
    }
    .export-result-info{
        display: flex;
        flex-direction: column;
        margin-left: 10px;
        margin-bottom: 30px;
    }
    .export-result-info span{
        margin-top: 15px;
    }
</style>
